import { compose } from '@reduxjs/toolkit';
import { fetchExportsReducer } from './fetchExports';

export const extraReducers = compose(fetchExportsReducer);
export { fetchExports } from './fetchExports';
